import { useState } from 'react';
import { getVersionedAudioUrl } from '../utils/audioUrl';

export default function useSampleWorkoutAudio(initialSequence) {
  const [isSamplePlaying, setIsSamplePlaying] = useState(false);
  const [sampleAudio, setSampleAudio] = useState(null);

  const handleSampleWorkout = (sequence = initialSequence) => {
    if (!Array.isArray(sequence) || sequence.length === 0) return;

    if (isSamplePlaying) {
      if (sampleAudio) {
        try {
          sampleAudio.pause();
          sampleAudio.currentTime = 0;
        } catch {}
      }
      setIsSamplePlaying(false);
      setSampleAudio(null);
      return;
    }

    let currentIndex = 0;

    const playNextAudio = () => {
      if (currentIndex >= sequence.length) {
        setIsSamplePlaying(false);
        setSampleAudio(null);
        return;
      }

      // Add timestamp versioning for automatic cache invalidation
      const versionedAudioUrl = getVersionedAudioUrl(sequence[currentIndex]);
      const audio = new Audio(versionedAudioUrl);

      audio.onended = () => {
        currentIndex += 1;
        playNextAudio();
      };

      audio.onerror = () => {
        setIsSamplePlaying(false);
        setSampleAudio(null);
        alert(
          'Sample audio not available. Please sign up to try the full experience!'
        );
      };

      audio
        .play()
        .then(() => {
          setIsSamplePlaying(true);
          setSampleAudio(audio);
        })
        .catch(() => {
          alert(
            'Sample audio not available. Please sign up to try the full experience!'
          );
        });
    };

    playNextAudio();
  };

  return { isSamplePlaying, handleSampleWorkout };
}
